import { normalize, schema } from "normalizr";
import { listTypes } from "@const/livestreams";

export const splitByRole = (participantsList = [], participantsById) => {
  let viewers = [];
  let moderators = [];
  let tippers = [];

  participantsList.forEach((id) => {
    const participant = participantsById[id];
    if (participant.listType === listTypes.tipper && !participant?.isBanned) {
      tippers.push(participant);
    } else if (participant.listType === listTypes.moderator) {
      moderators.push(participant);
    } else if (participant.listType === listTypes.viewer) {
      viewers.push(participant);
    }
  });

  return {
    viewers,
    moderators,
    tippers: tippers.sort((a, b) =>
      a.totalTipsAmount > b.totalTipsAmount ? -1 : 1,
    ),
  };
};

export const normalizeLivestreamArray = (originalLivestreams) => {
  const livestreamSchema = new schema.Entity("livestreams");

  const livestreams = new schema.Array(livestreamSchema);

  return normalize(originalLivestreams, livestreams);
};

export const getParticipantId = (participant) =>
  `${participant.id}-${participant.listType}`;

export const normalizeParticipantsArray = (originalParticipants) => {
  const allParticipants = [];
  const participantsById = [];
  (originalParticipants ?? []).forEach((participant) => {
    const participantKey = getParticipantId(participant);
    allParticipants.push(participantKey);
    participantsById[participantKey] = participant;
  });
  return {
    allParticipants,
    participantsById,
  };
};

export const getDuration = (startDate) => {
  if (!startDate) {
    return "00:00:00";
  }

  // Get the current time
  const now = new Date();

  // Calculate the difference in milliseconds
  const diff = now - new Date(startDate);

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((diff % (1000 * 60)) / 1000)
    .toString()
    .padStart(2, "0");

  // If the duration is less than 1 hour, return in MM:SS format
  if (hours === 0) {
    return `${minutes}:${seconds}`;
  }

  // If the duration is 1 hour or more, return in HH:MM:SS format
  const hoursFormatted = hours.toString().padStart(2, "0");
  return `${hoursFormatted}:${minutes}:${seconds}`;
};

export const captureLastFrame = ({ canvasRef }) => {
  const videoContainer = document.getElementById("localVideoContainer");

  const video = videoContainer.getElementsByClassName("agora_video_player")[0];
  const canvas = canvasRef.current;

  if (!(video instanceof HTMLVideoElement)) {
    console.error(
      "The video element was not found or is not an HTMLVideoElement.",
    );
    return null;
  }

  if (!(canvas instanceof HTMLCanvasElement)) {
    console.error("Canvas reference is not an HTMLCanvasElement.");
    return null;
  }

  const context = canvas.getContext("2d");
  if (!context) {
    console.error("Failed to get canvas 2D context.");
    return null;
  }

  if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
    console.error("Video is not ready.");
    return null;
  }

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  context.drawImage(video, 0, 0, canvas.width, canvas.height);

  return canvas.toDataURL("image/png");
};
